import Joi from '@hapi/joi'

export const MonthlyDivisionSummaryReportSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Select group`,
        "any.required": `Group required`
    }),
    estateID: Joi.number().invalid(0).required().label("Estate").messages({
        "any.invalid": `Select Estate`,
        "any.required": `Estate required`
    }),
    divisionID: Joi.number().label("Division").messages({
        "any.invalid": `Select Division`,
        "any.required": `Division required`
    }),
    fieldID: Joi.number().label("Field").messages({
    }),
    searchMonth: Joi.string().invalid("").required().label("Search Month").messages({
        "any.required": `Month required`
    })
}